export default {
  notifications: [],
  unreadCount: 0
}